import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from './api-base';

@Injectable({
  providedIn: 'root'
})
export class ControlsocialService {
  private apiUrl = `${API_BASE_URL}/controlsocial`;

  constructor(private http: HttpClient) {}

  getChannel(tenantId: number): Observable<{ channel: any | null }> {
    const params = new HttpParams().set('tenant_id', tenantId);
    return this.http.get<{ channel: any | null }>(`${this.apiUrl}/channel`, { params });
  }

  saveChannel(payload: any): Observable<{ channel: any | null }> {
    return this.http.post<{ channel: any | null }>(`${this.apiUrl}/channel`, payload);
  }

  listConversations(
    tenantId: number,
    filters?: {
      status?: string | null;
      search?: string | null;
      channel_id?: number | null;
      limit?: number | null;
      offset?: number | null;
    }
  ): Observable<any[]> {
    let params = new HttpParams().set('tenant_id', tenantId);
    if (filters?.status?.trim()) {
      params = params.set('status', filters.status.trim());
    }
    if (filters?.search?.trim()) {
      params = params.set('search', filters.search.trim());
    }
    if (filters?.channel_id) {
      params = params.set('channel_id', String(filters.channel_id));
    }
    if (filters?.limit) {
      params = params.set('limit', String(filters.limit));
    }
    if (filters?.offset) {
      params = params.set('offset', String(filters.offset));
    }
    return this.http.get<any[]>(`${this.apiUrl}/conversations`, { params });
  }

  listMessages(tenantId: number, conversationId: number, limit = 100, offset = 0): Observable<any[]> {
    let params = new HttpParams().set('tenant_id', tenantId);
    params = params.set('limit', String(limit));
    params = params.set('offset', String(offset));
    return this.http.get<any[]>(`${this.apiUrl}/conversations/${conversationId}/messages`, { params });
  }

  sendMessage(payload: {
    tenant_id: number;
    user_id: number;
    to: string;
    text: string;
    channel_id?: number | null;
    conversation_id?: number | null;
  }): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/messages/send`, payload);
  }
}
